(function () {
'use strict';

const ANIMATION = {
  typing(options) {
    let count = 0;
    let timer = null;
    timer = setInterval(() => {
      if (count > options.text.length) {
        clearInterval(timer);
        options.end();
      } else {
        options.target.textContent = options.text.substring(0, count++);
      }
    }, options.interval);
  },
  fadeIn(options) {
    options.target.transformDuration = options.duration + 'ms';
    options.target.classList.add('active');
    setTimeout(() => {
      options.end();
    }, options.duration);
  },
  fadeOut(options) {
    options.target.transformDuration = options.duration + 'ms';
    options.target.classList.remove('active');
    setTimeout(() => {
      options.end();
    }, options.duration);
  },
  click(options) {
    options.target.addEventListener('click', () => {
      options.end();
    }, false);
  }
};

let audioCanPlay = true;

class Animate {
  constructor(options, trigger) {
    this.id = options.id;
    this.target = options.target;
    this.type = options.type;
    this.text = options.text;
    this.animation = options.animation;
    this.delay = options.delay;
    this.duration = options.duration;
    this.next = options.next;
    this.action = options.action;
    this.audio = options.audio;
    this.trigger = trigger;
  }
  play() {
    const animation = ANIMATION[this.animation];
    if (animation) {
      switch (this.animation) {
        case 'fadeIn':
          animation({
            target: this.target,
            duration: this.duration,
            end: () => {
              this.trigger(this.next);
            },
          });
          break;
        case 'typing':
          animation({
            target: this.target,
            text: this.text,
            interval: Math.round(this.duration / this.text.length),
            end: () => {
              this.target.style.display = 'none';
              this.trigger(this.next);
            },
          });
          break;
        case 'click':
          animation({
            target: this.target,
            end: () => {
              if (typeof this.action === 'function') {
                this.action();
              }
              this.trigger(this.next);
            },
          });
          break;
        default:
          break;
      }
      if (this.audio && audioCanPlay) {
        this.audio.play();
      }
    } else {
      throw new Error(`The type of ${ this.type } animation is missing!`);
    }
  }
}

class AnimateList {
  constructor(list, end) {
    this.list = list.map(item => {
      return new Animate(item, next => {
        this.trigger(next);
      });
    });
    this.end = end;
  }
  trigger(next) {
    const target = this.findNext(this.list, next);
    if (target) {
      setTimeout(() => {
        target.play();
      }, target.delay);
    } else {
      this.end();
    }
  }
  findNext(list, id) {
    if (id !== null) {
      for (let key in list) {
        if (list[key].id === id) {
          return list[key];
        }
      }
    }
    return null;
  }
  start() {
    this.list[0].play();
  }
}

class Page {
  constructor(options, end) {
    this.target = options.target;
    this.animation = options.animation;
    this.delay = options.delay;
    this.duration = options.duration;
    this.animationList = new AnimateList(this.findTarget(options.animationList), end);
  }
  findTarget(list) {
    return list.map(item => {
      if (item.target) {
        if (typeof item.target === 'string') {
          item.target = this.target.querySelector(item.target);
        }
      } else {
        item.target = this.target;
      }
      return item;
    });
  }
}

class PageList {
  constructor(list) {
    this.list = list.map(item => {
      return new Page(item, () => {
        this.next();
      });
    });
    this.current = 0;
  }
  show(page, end) {
    page.target.style.display = 'block';
    setTimeout(() => {
      end(page);
    }, page.duration);
  }
  hide(page, end) {
    page.target.style.display = 'none';
    [...page.target.querySelectorAll('audio')].forEach(item => {
      item.pause();
    });
    setTimeout(() => {
      end(page);
    }, page.duration);
  }
  next() {
    if (this.current === this.list.length) {
      this.end();
      return false;
    }
    if (this.current !== 0) {
      this.hide(this.list[this.current - 1], () => {
        this.show(this.list[this.current], page => {
          page.animationList.start();
          this.current++;
        });
      });
    } else {
      this.show(this.list[this.current], page => {
        page.animationList.start();
        this.current++;
      });
    }
  }
  start() {
    this.next();
  }
  end() {
    document.querySelector('button.start').classList.add('active');
  }
}

const pageList = new PageList([
  {
    target: document.querySelector('.page-2'),
    animation: 'fadeIn',
    delay: 0,
    duration: 300,
    animationList: [
      {
        id: 'page-1-1',
        target: '.depiction p',
        type: 'text',
        text: '夜幕降临，曼哈顿街头灯火通明。一天逛累了，我钻进一家背街的小酒吧。',
        animation: 'typing',
        delay: 0,
        duration: 2000,
        audio: document.querySelector('.audio-01'),
        next: 'page-2-1',
      },
      {
        id: 'page-2-1',
        target: '.sc-01',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 1600,
        next: 'page-2-2',
      },
      {
        id: 'page-2-2',
        target: '.sc-02',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 1000,
        next: 'page-2-3',
      },
      {
        id: 'page-2-3',
        target: '.gesture',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 300,
        next: 'page-2-4',
      },
      {
        id: 'page-2-4',
        type: 'action',
        animation: 'click',
        delay: 0,
        duration: 0,
        next: null,
      },
    ]
  },
  {
    target: document.querySelector('.page-4'),
    animation: 'fadeIn',
    delay: 0,
    duration: 300,
    animationList: [
      {
        id: 'page-3-1',
        target: '.depiction p',
        type: 'text',
        text: '见到吧台还有空位，我坐下点了杯饮料。感觉旁边的男人身上酒味很重……',
        animation: 'typing',
        delay: 0,
        duration: 2750,
        next: 'page-4-1',
      },
      {
        id: 'page-4-1',
        target: '.sc-03',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 1000,
        audio: document.querySelector('.audio-03'),
        next: 'page-4-2',
      },
      {
        id: 'page-4-2',
        target: '.sc-04',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 1000,
        audio: document.querySelector('.audio-02'),
        next: 'page-4-3',
      },
      {
        id: 'page-4-3',
        target: '.sc-05',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 1000,
        next: 'page-4-4',
      },
      {
        id: 'page-4-4',
        target: '.sc-06',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 1000,
        next: 'page-4-5',
      },
      {
        id: 'page-4-5',
        target: '.sc-07',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 1000,
        next: 'page-4-6',
      },
      {
        id: 'page-4-6',
        target: '.gesture',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 1000,
        next: 'page-4-7',
      },
      {
        id: 'page-4-7',
        type: 'action',
        animation: 'click',
        delay: 0,
        duration: 0,
        next: null,
      },
    ]
  },
  {
    target: document.querySelector('.page-6'),
    animation: 'fadeIn',
    delay: 0,
    duration: 300,
    animationList: [
      {
        id: 'page-5-1',
        target: '.depiction p',
        type: 'text',
        text: '我喝了口饮料，放下酒杯，暗自猜想旁边那位痛饮的原因……突然，他手肘一推，碰翻了我的酒杯……',
        animation: 'typing',
        delay: 0,
        duration: 3000,
        next: 'page-6-1',
      },
      {
        id: 'page-6-1',
        target: '.sc-08',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 800,
        audio: document.querySelector('.audio-04'),
        next: 'page-6-2',
      },
      {
        id: 'page-6-2',
        target: '.sc-09',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 800,
        audio: document.querySelector('.audio-05'),
        next: 'page-6-3',
      },
      {
        id: 'page-6-3',
        target: '.sc-10',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 500,
        next: 'page-6-4',
      },
      {
        id: 'page-6-4',
        target: '.gesture',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 300,
        next: 'page-6-5',
      },
      {
        id: 'page-6-5',
        type: 'action',
        animation: 'click',
        delay: 0,
        duration: 0,
        next: null,
      },
    ]
  },
  {
    target: document.querySelector('.page-7'),
    animation: 'fadeIn',
    delay: 0,
    duration: 300,
    animationList: [
      {
        id: 'page-7-1',
        target: '.sc-11',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 800,
        next: 'page-7-2',
      },
      {
        id: 'page-7-2',
        target: '.sc-12',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 800,
        audio: document.querySelector('.audio-06'),
        next: 'page-7-3',
      },
      {
        id: 'page-7-3',
        target: '.sc-13',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 800,
        next: 'page-7-4',
      },
    ]
  },
]);

pageList.start();

document.querySelector('.bg-music').addEventListener('click', ev => {
  if (audioCanPlay) {
    audioCanPlay = false;
    ev.currentTarget.classList.add('paused');
    [...document.querySelectorAll('audio')].forEach(item => {
      item.pause();
    });
  } else {
    audioCanPlay = true;
    ev.currentTarget.classList.remove('paused');
  }
});

[...document.querySelectorAll('audio')].forEach(item => {
  item.play();
  document.addEventListener('WeixinJSBridgeReady', function () {
    item.play();
    setTimeout(() => {
      item.pause();
    }, 0);
  }, false);
  setTimeout(() => {
    item.pause();
  }, 0);
});

}());
